import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin-top: ', 'px;\n  margin-bottom: ', 'px;\n  margin-left: -', 'px;\n  height: ', 'px;\n  background: ', ';\n  border-radius: 1px;\n'], ['\n  margin-top: ', 'px;\n  margin-bottom: ', 'px;\n  margin-left: -', 'px;\n  height: ', 'px;\n  background: ', ';\n  border-radius: 1px;\n']);

import styled from 'styled-components';
import { gridSize } from '../../shared-variables';
import { getProvided } from '../../theme/util';

var dividerLineHeight = 2;
var dividerTotalHeight = gridSize * 5;

var NavigationItemGroupSeparator = styled.div(_templateObject, (dividerTotalHeight - dividerLineHeight) / 2, (dividerTotalHeight - dividerLineHeight) / 2, gridSize, dividerLineHeight, function (_ref) {
  var theme = _ref.theme;
  return getProvided(theme).keyline;
});

NavigationItemGroupSeparator.displayName = 'NavigationItemGroupSeparator';

export default NavigationItemGroupSeparator;